<template>
  <div>
    <NavbarDashboard v-if="navarView" />
    <div :class="{ 'app-content': navarView }">
      <router-view />
    </div>
    <ChatbotFlotante v-if="navarView" />
  </div>
</template>

<script>
import NavbarDashboard from './components/NvarDashboard.vue';
import ChatbotFlotante from './components/ChatbotFlotante.vue';
export default {
  name: "App",
  data() {
    return {
      navarView : null
    };
  },
  components: {
    NavbarDashboard,
    ChatbotFlotante
  },methods:{
    cargarNavbar() {
      const token = localStorage.getItem("token");
      this.navarView = !!token; // Si hay token, mostrar navbar
    }
  },
  mounted() {
    this.cargarNavbar();
  }

}
</script>

<style>
/* El drawer publica su ancho en --drawer-w (0 en móvil) */
.app-content {
  margin-left: var(--drawer-w, 0px);
  min-width: 0;
  transition: margin-left 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}
</style>
